import React, { useEffect } from 'react'
import FiberManualRecord from '@mui/icons-material/FiberManualRecord';
import Checkbox from '@mui/material/Checkbox';

import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { Tooltip, Box, Divider, Chip, Typography } from '@mui/material';
import dayjs from 'dayjs';


import { AvatarDynamic } from '../../components/avatar';

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        //   backgroundColor: '#44b700',
        //   color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));



const Shift = ({ states, shiftsByUsers, analyticsMap, map }) => {

    // console.log("prps", props.states);

    useEffect(()=> {
        console.log('shiftsByUsers',shiftsByUsers, map.Shifts)
    })
    return (
        <div className='row'>
            {Object.values(states).map((s, i) => {
                const analyticsData = analyticsMap[s.user._id] || {}
                const stt = { pl: 2, pr: 2, pb: 1, pt: 1, width: '8em' }
                const { totalAllocated, attempted, completed, transferred, retry, totalAllocatedI, attemptedI, completedI, transferredI, retryI, totalPending, totalPendingI } = analyticsData
                return (

                    <div className='col-md-4 p-2'>

                        <div className='d-flex border border-danger rounded py-2 small' style={{ fontSize: 'x-small', overflow: 'hidden', display: 'flex', justifyContent: 'space-between', }}>
                            <Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className='d-flex align-items-center m-0 p-0'>
                                        <Checkbox size='small' />
                                    </div>
                                    <div className='m-1 ml-0 d-flex align=items-center'>
                                        <div className=''>
                                            <AvatarDynamic color={s.state === 'online' ? 'success' : 'error'} src="https://cdn-icons-png.flaticon.com/512/3541/3541871.png" />

                                        </div>
                                    </div>
                                    <div className='m-1 mr-0'>
                                        <div className='text-danger'>
                                            <strong>{s.user.name} </strong>
                                        </div>
                                        <div style={{ fontSize: 'x-small' }}>
                                            {s.user.uuid}
                                        </div>
                                    </div>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' , padding: '1em'}}>
                                    {
                                        map.Shifts[shiftsByUsers[s.user._id]?.[0]?.shift]?
                                        <Chip size="small" sx={{fontSize:'10px'}} label={`${map.Shifts[shiftsByUsers[s.user._id]?.[0]?.shift]?.name} (${dayjs(map.Shifts[shiftsByUsers[s.user._id]?.[0]?.shift]?.start).format('hh:mm:A')}-${dayjs(map.Shifts[shiftsByUsers[s.user._id]?.[0]?.shift]?.end).format('hh:mm:A')})`} color="primary"  variant="outlined"/>
                                        :<Typography sx={{fontSize:'1.2em', color: 'grey'}}>No shift alloted</Typography>

                                    }

                                </Box>
                            </Box>

                            {
                                analyticsData &&
                                <Box sx={{ display: 'flex', flexDirection: 'column', mr: 3 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Box sx={stt}>
                                            <Tooltip title={`Outbound: ${totalAllocated}/ Inbound: ${totalAllocatedI}`} placement="bottom">

                                                <div className='text-center' style={{ cursor: 'pointer' }}>
                                                    Alloted
                                                </div>
                                            </Tooltip>
                                            <div className='text-center'>
                                                <strong>
                                                    {(totalAllocated || 0) + (totalAllocatedI || 0)}
                                                </strong>
                                            </div>
                                        </Box>
                                        <Box sx={stt}>
                                            <Tooltip title={`Outbound: ${completed}/ Inbound: ${completedI}`} placement="bottom">
                                                <div className='text-center' style={{ cursor: 'pointer' }}>
                                                    Completed
                                                </div>
                                            </Tooltip>
                                            <div className='text-center'>
                                                <strong>
                                                    {(completed || 0) + (completedI || 0)}
                                                </strong>
                                            </div>
                                        </Box>
                                        <Box sx={stt}>
                                            <Tooltip title={`Outbound: ${transferred}/ Inbound: ${transferredI}`} placement="bottom">
                                                <div className='text-center' style={{ cursor: 'pointer' }}>
                                                    Transferred
                                                </div>
                                            </Tooltip>
                                            <div className='text-center'>
                                                <strong>
                                                    {(transferred || 0) + (transferredI || 0)}
                                                </strong>
                                            </div>
                                        </Box>

                                    </Box>
                                    <Divider />
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

                                        <Box sx={stt}>
                                            <Tooltip title={`Outbound: ${attempted}/ Inbound: ${attemptedI}`} placement="bottom">
                                                <div className='text-center' style={{ cursor: 'pointer' }}>
                                                    Attempted
                                                </div>
                                            </Tooltip>
                                            <div className='text-center'>
                                                <strong>
                                                    {(attempted || 0) + (attemptedI || 0)}
                                                </strong>
                                            </div>
                                        </Box>
                                        <Box sx={stt}>
                                            <Tooltip title={`Outbound: ${totalPending}/ Inbound: ${totalPendingI}`} placement="bottom">
                                                <div className='text-center' style={{ cursor: 'pointer' }}>
                                                    Pending
                                                </div>
                                            </Tooltip>
                                            <div className='text-center'>
                                                <strong>
                                                    {(totalPending || 0) + (totalPendingI || 0)}
                                                </strong>
                                            </div>
                                        </Box>

                                        <Box sx={stt}   >
                                            <Tooltip title={`Outbound: ${retry}/ Inbound: ${retryI}`} placement="bottom">
                                                <div className='text-center' style={{ cursor: 'pointer' }}>
                                                    Retry
                                                </div>
                                            </Tooltip>
                                            <div className='text-center'>
                                                <strong>
                                                    {(retry || 0) + (retryI || 0)}
                                                </strong>
                                            </div>
                                        </Box>
                                    </Box>

                                </Box>
                            }


                        </div>


                    </div>
                )
            })}

        </div>
    )
}

export default Shift;